"use client";

import React, { useState } from 'react';
import { useToast } from '@/components/ui/Toast';

const adjectives = ['Cool', 'Swift', 'Bright', 'Neon', 'Dark', 'Epic', 'Wild', 'Silent', 'Golden', 'Hyper'];
const nouns = ['Panda', 'Eagle', 'Coder', 'Ghost', 'Knight', 'Wizard', 'Wolf', 'Storm', 'Shadow', 'Dragon'];

export default function UsernameGeneratorClient() {
    const [usernames, setUsernames] = useState<string[]>([]);
    const [useNumbers, setUseNumbers] = useState(true);
    const { showToast } = useToast();

    const generateUsernames = () => {
        const list = [];
        for (let i = 0; i < 10; i++) {
            const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
            const noun = nouns[Math.floor(Math.random() * nouns.length)];
            const num = useNumbers ? Math.floor(Math.random() * 999) : '';
            list.push(`${adj}${noun}${num}`);
        }
        setUsernames(list);
        showToast('Generated 10 unique usernames!');
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', userSelect: 'none' }}>
                    <input
                        type="checkbox"
                        checked={useNumbers}
                        onChange={(e) => setUseNumbers(e.target.checked)}
                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    />
                    Include Numbers
                </label>
            </div>

            <button onClick={generateUsernames} className="btn-primary" style={{ minWidth: '200px', height: '52px' }}>
                Generate Usernames
            </button>

            {usernames.length > 0 && (
                <div style={{ width: '100%' }}>
                    <p style={{ textAlign: 'center', fontSize: '0.9rem', color: 'var(--secondary)', marginBottom: '1rem' }}>Click any name to copy</p>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: '1rem',
                        width: '100%'
                    }}>
                        {usernames.map((name, index) => (
                            <div
                                key={index}
                                onClick={() => {
                                    navigator.clipboard.writeText(name);
                                    showToast(`Copied: ${name}`);
                                }}
                                style={{
                                    padding: '1.25rem',
                                    background: 'var(--accent)',
                                    border: '1px solid var(--border)',
                                    borderRadius: '12px',
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: '#1e293b'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.background = '#eff6ff';
                                    e.currentTarget.style.borderColor = '#3b82f6';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.background = 'var(--accent)';
                                    e.currentTarget.style.borderColor = 'var(--border)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                {name}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}




